import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import Dialog from '../../Dialog';
import SpinnerLoader from '../../Loader/Spinner';
import { isPassengerNameModified } from './helper';
import { ReviewProps } from './index.types';
import PassengerName from './PassengerName';

function ReviewModification({ data, loading, open, onClose, onSubmit }: ReviewProps) {
    return (
        <Dialog open={open} classes={{ container: '!min-w-full' }}>
            <div className='flex flex-col gap-15 grow p-20'>
                <div className='flex flex-col gap-5'>
                    <Typography variant='h4' className='font-medium'>
                        Review Corrections
                    </Typography>
                    <Typography className='text-neutral-600'>
                        Please ensure that the updated names are correct
                    </Typography>
                </div>
                <div className='flex flex-col gap-15'>
                    {data.map((passenger) =>
                        isPassengerNameModified(passenger) ? (
                            <div key={passenger.id} className='p-10 bg-neutral-40 rounded-10'>
                                <PassengerName data={passenger} />
                            </div>
                        ) : null,
                    )}
                </div>
            </div>
            <div className='flex gap-20 border-t px-20 py-10'>
                <Button variant='soft' size='lg' className='w-full' onClick={onClose} disabled={loading}>
                    Edit
                </Button>
                <Button size='lg' className='w-full' onClick={onSubmit} disabled={loading}>
                    {loading ? <SpinnerLoader className='px-20' size='sm' /> : 'Submit'}
                </Button>
            </div>
        </Dialog>
    );
}

export default ReviewModification;
